import React from "react";
import { HeaderBasic } from "./HeaderBasic";
import { Main } from "./Main";
import { HeaderNav } from "./HeaderNav";
import { GridContainer, GridFlexSpacer } from "../Grid";

interface TemplateBasicProps {
    children?: React.ReactNode;
    [key: string]: unknown;
}

const TemplateBasic: React.FC<TemplateBasicProps> = (props) => {
    const { children } = props;
    return (
        <>
            <noscript>You need to enable JavaScript to run this app.</noscript>
            <HeaderBasic />
            <HeaderNav {...(props as unknown as React.ComponentProps<typeof HeaderNav>)} />
            <Main>
                <GridContainer hasMarginY>
                    <GridFlexSpacer>
                        {children}
                    </GridFlexSpacer>
                </GridContainer>
            </Main>
        </>
    );
};


export const TemplateBasicHeader: React.FC<TemplateBasicProps> = (props) => TemplateBasic({ ...props });
